import { Controller } from '@hotwired/stimulus';
import { modalLinkUrl, setModalLinkUrl } from "../../utils/modal_link";

export default class extends Controller {
  static targets = [
    'propertyRow',
    'statusBadge',
    'inspectionDate',
    'valuerDue',
    'lenderDue',
    'midPr',
    'qcPr',
    'dot',
    'dotLabel',
    'counterText',
    'prevButton',
    'nextButton',
    'detailsLink',
  ];

  static values = { propertyIds: Array, initialIndex: Number };

  connect() {
    this.currentIndex = this.hasInitialIndexValue ? this.initialIndexValue : 0;
    this.updateView();
  }

  next(event) {
    event.stopPropagation();
    if (this.currentIndex < this.dotTargets.length - 1) {
      this.currentIndex++;
      this.updateView(true);
    }
  }

  prev(event) {
    event.stopPropagation();
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateView(true);
    }
  }

  goTo(event) {
    event.stopPropagation();
    const index = parseInt(event.params.index, 10);
    if (!isNaN(index) && index >= 0 && index < this.dotTargets.length) {
      this.currentIndex = index;
      this.updateView(true);
    }
  }

  updateView(animate = false) {
    const total = this.dotTargets.length;

    this.#toggleByIndex(this.propertyRowTargets, animate);
    this.#toggleByIndex(this.statusBadgeTargets);
    this.#toggleByIndex(this.inspectionDateTargets);
    this.#toggleByIndex(this.valuerDueTargets);
    this.#toggleByIndex(this.lenderDueTargets);
    this.#toggleByIndex(this.midPrTargets);
    this.#toggleByIndex(this.qcPrTargets);

    this.dotTargets.forEach((dot, i) => {
      const active = i === this.currentIndex;
      if (active) {
        dot.classList.remove('w-10', 'h-10', 'border', 'border-black-300', 'bg-white');
        dot.classList.add('w-24', 'h-24', 'bg-brand-1000');
      } else {
        dot.classList.remove('w-24', 'h-24', 'bg-brand-1000');
        dot.classList.add('w-10', 'h-10', 'border', 'border-black-300', 'bg-white');
      }
    });

    this.dotLabelTargets.forEach((label, i) => {
      label.classList.toggle('hidden', i !== this.currentIndex);
    });

    if (this.hasCounterTextTarget) {
      this.counterTextTarget.textContent = `${this.currentIndex + 1}/${total}`;
    }

    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.disabled = this.currentIndex === 0;
    }

    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.disabled = this.currentIndex === total - 1;
    }

    this.#updateDetailsLink();
  }

  #updateDetailsLink() {
    if (!this.hasDetailsLinkTarget || !this.hasPropertyIdsValue) return;

    const propertyId = this.propertyIdsValue[this.currentIndex];
    if (!propertyId) return;

    const url = new URL(modalLinkUrl(this.detailsLinkTarget), window.location.origin);
    url.searchParams.set('property_id', propertyId);
    setModalLinkUrl(this.detailsLinkTarget, `${url.pathname}${url.search}`);
  }

  #toggleByIndex(targets, animate = false) {
    targets.forEach((el, i) => {
      const active = i === this.currentIndex;
      el.classList.toggle('hidden', !active);
      if (animate && active) {
        el.classList.remove('animate-property-highlight');
        el.offsetHeight;
        el.classList.add('animate-property-highlight');
      }
    });
  }
}
